import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'dashboard-statistic',
	templateUrl: './statistic.component.html',
	styleUrls: ['./statistic.component.scss'],
})
export class StatisticComponent implements OnInit {
	@Input() mode: string = 'content';

	toolTip: string = '';

	statistics: any[] = [
		{
			name: 'Umsätze',
			data: 12000,
			olddata: 4000,
			sign: '€'
		},
		{
			name: 'Neue Käufer',
			data: 105,
			olddata: 80,
			sign: ''
		},
		{
			name: 'Anzahl der Besuche',
			data: 768,
			olddata: 1230,
			sign: ''
		},
		{
			name: 'Termin',
			data: 92,
			olddata: 89,
			sign: ''
		}
	]
	constructor() { }

	ngOnInit() {
		
	}

	toolTipT(toolTip) {
		if(this.toolTip === '') {
			this.toolTip = toolTip
		} else {
			this.toolTip = ''
		}
	}
}
